
import { TextBulletListSquare24Regular, TextBulletListSquare24Filled, bundleIcon } from "@fluentui/react-icons";

export const ViewIcon = bundleIcon(TextBulletListSquare24Filled, TextBulletListSquare24Regular);